import { cache } from '../cache-impl/cache-registry';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../webmodule-common/other/dispose';
import { FranchiseeProjectListView } from '../projects/views/franchisee-project-list-view';
import { getInternalId } from '../../../webmodule-common/other/ui/databinding/databinding';
import { html } from 'lit';
import { ProjectListView } from '../../projects/views/project-list-view';
import { TabbedPageBase } from './helpers/page-base';
import { LangAppProjectsPage } from '../../../localization/scripts/dealer-franchisee/pages/app-projects-lang';
import { userDataStore } from '../common/current-user-data-store';

@customElement('app-projects')
export class AppProjectsPage extends TabbedPageBase {
  @state()
  projectListView: ProjectListView | null = null;
  internalId: string = getInternalId();

  constructor() {
    super();
  }

  protected async setActiveTabByHash() {
    await this.projectListView?.setActiveTabByHash();
  }

  private get elementId(): string {
    return `project-page-${this.internalId}`;
  }

  protected async afterUserConnected() {
    this.projectListView = this.projectViewFactory();
    await super.afterUserConnected();
  }

  async dispose() {
    await super.dispose();
    await disposeOf(this.projectListView);
    this.projectListView = null;
  }

  render() {
    if (!this.loggedIn) return html``;
    return html`
      <div id=${this.elementId} class="page-content">
        <div class="page-container">${this.projectListView?.ui}</div>
      </div>
    `;
  }

  meta() {
    return {
      title: () => LangAppProjectsPage.projectSummaryTitle(),
      description: 'SoftTech dealer CPQ'
    };
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  private projectViewFactory() {
    //change this to a subclass which has branch details, or otherwise.. ie FranchiseeBranchQuoteListView
    return new FranchiseeProjectListView({
      projectOwnerId: async () => {
        await userDataStore.loadCoreDetails();
        //this will need to be changed to a franchisee branch that the user belongs to
        if (!userDataStore.defaultBranch) return '';
        return userDataStore.defaultBranch.id;
      },
      quoteCache: cache().quote,
      purchaseOrderCache: cache().purchaseOrder,
      clientCache: cache().client,
      userProfileCache: cache().userProfile,
      paymentProfileCache: cache().paymentProfile,
      contactCache: cache().contact
    });
  }
}
